/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whoareyou_SubInputs */

const th_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอนนี้คุณกำลังติดตามในฐานะผู้ชม บอกเราหากคุณเป็นมากกว่านั้น`)
};

const en_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are following along as a spectator. Tell us if you are more than that.`)
};

const ja_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在は観戦者として閲覧しています。それ以外の立場であればお知らせください。`)
};

const zh_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你正以观众的身份关注这一切。如果你不止于此，请告诉我们。`)
};

const es_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora mismo sigues la plataforma como espectador. Dinos si eres algo más.`)
};

const pt_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está acompanhando como espectador. Conte se você é mais do que isso.`)
};

const id_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mengikuti semuanya sebagai penonton. Beri tahu kami jika Anda lebih dari itu.`)
};

const fr_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous suivez en tant que spectateur. Dites-nous si vous êtes plus que cela.`)
};

const tl_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinusundan mo ang lahat bilang manonood. Sabihin sa amin kung higit ka pa roon.`)
};

const vi_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đang theo dõi mọi thứ với tư cách khán giả. Hãy cho chúng tôi biết nếu bạn còn hơn thế.`)
};

const ko_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지금은 관중으로 보고 계십니다. 그 이상이라면 알려주세요.`)
};

const de_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du verfolgst das Ganze als Zuschauer. Sag uns, wenn du mehr bist.`)
};

const ru_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы следите за всем как зритель. Скажите нам, если вы кто-то больше.`)
};

const tr_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her şeyi bir seyirci olarak takip ediyorsunuz. Bundan fazlasıysanız bize söyleyin.`)
};

const it_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stai seguendo tutto da spettatore. Dicci se sei qualcosa di più.`)
};

const pl_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzisz wszystko jako widz. Powiedz nam, jeśli jesteś kimś więcej.`)
};

const uk_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви стежите за всім як глядач. Скажіть нам, якщо ви щось більше.`)
};

const hi_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप सब कुछ एक दर्शक के रूप में देख रहे हैं। अगर आप इससे अधिक हैं तो हमें बताएँ।`)
};

const ar_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنت تتابع كل شيء كمشاهد. أخبرنا إن كنت أكثر من ذلك.`)
};

const ms_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mengikuti semuanya sebagai penonton. Beritahu kami jika anda lebih daripada itu.`)
};

const bn_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি সব কিছু দর্শক হিসেবে দেখছেন। এর বেশি কিছু হলে আমাদের জানান।`)
};

const zh_tw2_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你正以觀眾的身分關注這一切。如果你不只如此，請告訴我們。`)
};

const zh_hk2_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你正以觀眾的身分關注這一切。如果你不只如此，請告訴我們。`)
};

const ur_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ سب کچھ ایک ناظر کے طور پر دیکھ رہے ہیں۔ اگر آپ اس سے بڑھ کر ہیں تو ہمیں بتائیں۔`)
};

const fa_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شما همه‌چیز را در جایگاه تماشاگر دنبال می‌کنید. اگر بیش از این هستید به ما بگویید.`)
};

const sw_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unafuatilia kila kitu kama mtazamaji. Tuambie kama wewe ni zaidi ya hapo.`)
};

const nl_whoareyou_sub = /** @type {(inputs: Whoareyou_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je volgt alles als toeschouwer. Laat het ons weten als je meer bent.`)
};

/**
* | output |
* | --- |
* | "You are following along as a spectator. Tell us if you are more than that." |
*
* @param {Whoareyou_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const whoareyou_sub = /** @type {((inputs?: Whoareyou_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whoareyou_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_whoareyou_sub(inputs)
	if (locale === "ja") return ja_whoareyou_sub(inputs)
	if (locale === "zh") return zh_whoareyou_sub(inputs)
	if (locale === "es") return es_whoareyou_sub(inputs)
	if (locale === "pt") return pt_whoareyou_sub(inputs)
	if (locale === "id") return id_whoareyou_sub(inputs)
	if (locale === "fr") return fr_whoareyou_sub(inputs)
	if (locale === "tl") return tl_whoareyou_sub(inputs)
	if (locale === "vi") return vi_whoareyou_sub(inputs)
	if (locale === "ko") return ko_whoareyou_sub(inputs)
	if (locale === "de") return de_whoareyou_sub(inputs)
	if (locale === "ru") return ru_whoareyou_sub(inputs)
	if (locale === "tr") return tr_whoareyou_sub(inputs)
	if (locale === "it") return it_whoareyou_sub(inputs)
	if (locale === "pl") return pl_whoareyou_sub(inputs)
	if (locale === "uk") return uk_whoareyou_sub(inputs)
	if (locale === "hi") return hi_whoareyou_sub(inputs)
	if (locale === "ar") return ar_whoareyou_sub(inputs)
	if (locale === "ms") return ms_whoareyou_sub(inputs)
	if (locale === "bn") return bn_whoareyou_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_whoareyou_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_whoareyou_sub(inputs)
	if (locale === "ur") return ur_whoareyou_sub(inputs)
	if (locale === "fa") return fa_whoareyou_sub(inputs)
	if (locale === "sw") return sw_whoareyou_sub(inputs)
	if (locale === "nl") return nl_whoareyou_sub(inputs)
	return en_whoareyou_sub(inputs)
});